export default "__VITE_ASSET__3597c62f__"